module.exports = __webpack_public_path__ + "static/otros-1001409e3ee6fbfe9b2e424fe1f042dd.png";